import { render, staticRenderFns } from "./DonutChart33.vue?vue&type=template&id=d4e3e43e&scoped=true"
import script from "./DonutChart33.vue?vue&type=script&lang=js"
export * from "./DonutChart33.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e3e43e",
  null
  
)

export default component.exports